import { Component, EventEmitter, Output } from '@angular/core';
import { UntypedFormBuilder, Validators, UntypedFormGroup } from '@angular/forms';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { AuthenticationService } from '@app/_services/authentication.service';
import { ToastrService } from 'ngx-toastr';
import * as _ from 'lodash';
import { TranslateHelper } from '@app/_helpers';
import { TranslateModule } from '@ngx-translate/core';
import { CurrencySelectComponent } from '../../../../_components/inputs/currency-select/currency-select.component';
import { NgIf } from '@angular/common';

@Component({
    selector: 'app-account-menu',
    templateUrl: './account-menu.component.html',
    styleUrls: ['./account-menu.component.scss'],
    providers: [TranslateHelper],
    standalone: true,
    imports: [NgIf, RouterLink, CurrencySelectComponent, TranslateModule]
})
export class AccountMenuComponent {
    @Output() closeMenu: EventEmitter<void> = new EventEmitter<void>();

    constructor(private fb: UntypedFormBuilder,
        private authenticationService: AuthenticationService,
        private toast: ToastrService,
        private router: Router,
        private translateHelper: TranslateHelper,
        private toastr: ToastrService,
        private activatedRoute: ActivatedRoute) { }

    form: UntypedFormGroup = this.fb.group({
        email: [null, [Validators.required]],
        password: [null, Validators.required]
    });
    submitted = false
    returnUrl: string;
    user;

    ngOnInit(): void {
        // const user = JSON.parse(localStorage.getItem('currentUser'));
        this.authenticationService.currentUser.subscribe((user): any => {
            if (user)
                this.user = user;
            else
                this.user = null;
        });

        this.activatedRoute.queryParams.subscribe(params =>{
            this.returnUrl = params['returnUrl'] || this.router.url || '/';
        })

    }

    logout() {
        this.authenticationService.logout().subscribe(() => {
            this.form.reset();
            this.closeMenu.emit();
        });

    }
    login() {
        this.submitted = true;

        if (this.form.invalid) return;
        this.authenticationService.login(this.form.value).subscribe((user) => {
            if (user.code == 400) {
                this.toastr.error(this.translateHelper.getTranslation("err_name_password"));
                                return;
            }
            this.router.routeReuseStrategy.shouldReuseRoute = () => false;
            this.router.onSameUrlNavigation = 'reload';
             this.router.navigate([this.returnUrl], { relativeTo: this.activatedRoute });
            if(!_.isEmpty(user.data))
            this.user = user.data;
            else
            this.user = null;

            this.closeMenu.emit()
            this.toast.success(`Welcome Back ${user.data?.name}`);
        }, (error) => {
            this.toastr.error(this.translateHelper.getTranslation("err_name_password"));
                });
    }



}
